import React from "react";
import { Icon } from "../../../../components";

const JoeIcon = () => <Icon name={"joe"} />;

export default JoeIcon;
